var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "31px",
    viewBox: "0 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "128C41BB-20B0-497E-A3B7-A67EDD01DA39") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A74E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6FE6",
    offset: "31.4717061%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D69EA",
    offset: "66.8206292%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8358ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "In-Game-Achievement-Icon",
    transform: "translate(-16.000000, -18.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(16.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3167716,6.62588409 L28.4775333,12.2800642 C28.2566128,13.7819197 26.9313783,14.9745442 25.4296671,14.9745442 L23.8393568,14.9745442 L24.6344398,5.69819105 L28.4332338,5.69819105 C28.78662,5.69819105 29.0075406,5.83080109 29.0958511,5.96326682 C29.2284611,6.05172161 29.3609268,6.27249783 29.3167716,6.62588409 L29.3167716,6.62588409 Z M21.1447324,15.858082 C20.9239562,18.3757967 18.8477939,20.2753381 16.2856353,20.2753381 L15.8439386,20.2753381 C13.3262238,20.2753381 11.2059063,18.3757967 10.9849858,15.858082 L9.83651652,2.60616953 L22.2491907,2.60616953 L21.1447324,15.858082 Z M3.65232918,12.2800642 L2.81294663,6.62588409 C2.76879139,6.27249783 2.90125712,6.05172161 3.03386715,5.96326682 C3.12217764,5.83080109 3.34309816,5.69819105 3.69648442,5.69819105 L7.49527846,5.69819105 L8.29050576,14.9745442 L6.70019545,14.9745442 C5.19833994,14.9745442 3.8731054,13.7819197 3.65232918,12.2800642 L3.65232918,12.2800642 Z M28.4332338,3.04786628 L24.855216,3.04786628 L24.987826,1.28093499 C25.0319813,0.927548737 24.8995155,0.618317725 24.6344398,0.353386257 C24.369364,0.0883104896 24.0159777,0 23.6625915,0 L8.334661,0 C7.98127475,0 7.62788849,0.0883104896 7.36281272,0.353386257 C7.09773695,0.618317725 6.96527122,1.01600353 7.00942646,1.36924548 L7.1418922,3.09202152 L3.56387439,3.09202152 C2.54801516,3.09202152 1.57616688,3.48956302 0.869394368,4.28464603 C0.206777099,5.07987333 -0.102453913,6.05172161 0.03015612,7.06758083 L0.869394368,12.7217609 C1.26693587,15.5046957 3.74063967,17.6691685 6.56772972,17.6691685 L8.55543723,17.6691685 C9.39467547,20.3194933 11.7359135,22.3072008 14.6071588,22.7047423 L14.6071588,28.2264567 L10.0572927,28.2264567 C9.30636498,28.2264567 8.7322025,28.8006192 8.7322025,29.5515469 C8.7322025,30.302619 9.30636498,30.8767815 10.0572927,30.8767815 L21.8073497,30.8767815 C22.5582775,30.8767815 23.1325842,30.302619 23.1325842,29.5515469 C23.1325842,28.8006192 22.5582775,28.2264567 21.8073497,28.2264567 L17.3900936,28.2264567 L17.3900936,22.6607314 C20.2613389,22.2631899 22.5582775,20.2753381 23.441671,17.624869 L25.4295228,17.624869 C28.2564685,17.624869 30.6860171,15.4605405 31.1278581,12.6776057 L31.9670964,7.02342559 C32.0995621,6.00742206 31.8344863,5.03557378 31.1278581,4.24063508 C30.4652408,3.44540778 29.4935369,3.04786628 28.4332338,3.04786628 L28.4332338,3.04786628 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement);
export default __webpack_public_path__ + "static/media/achievement.23f0ef22615d90737a57920ae964b434.svg";
export { ForwardRef as ReactComponent };